import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import { ThemeType, mixins } from "@theme";
import { MenuItem } from "./types";
import { Menu } from "./Menu";

type Props = {
  items: MenuItem[];
  onItemClick: (item: MenuItem) => any;
};

export function MainMenu(props: Props) {
  const classes = useStyles({});

  return (
    <List
      component={"nav" as any}
      classes={{ root: classes.root }}
      data-test="MainMenu"
    >
      <Menu items={props.items} onItemClick={props.onItemClick} />
    </List>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  ...mixins.withListItem(theme),

  root: {
    paddingTop: 0
  }
}));

MainMenu.defaultProps = {
  items: []
};
